import { IdmsUploadsTypeEnum } from '@/__generated__/graphql';

export const idmsTemplates = [
  {
    name: 'APM Line Metadata',
    type: IdmsUploadsTypeEnum.ApmLineMetadata,
    path: '/assets/idms-templates/apm-line-metadata.csv',
  },
  {
    name: 'APM Task Number',
    type: IdmsUploadsTypeEnum.ApmTaskNumber,
    path: '/assets/idms-templates/apm-task-number.csv',
  },
  {
    name: 'APM Task Status',
    type: IdmsUploadsTypeEnum.ApmTaskStatus,
    path: '/assets/idms-templates/apm-task-status.csv',
  },
  {
    name: 'APM Work Order',
    type: IdmsUploadsTypeEnum.ApmWorkOrder,
    path: '/assets/idms-templates/apm-work-order.csv',
  },
  {
    name: 'APM Work Order Status',
    type: IdmsUploadsTypeEnum.WorkOrderStatus,
    path: '/assets/idms-templates/work-order-status.csv',
  },
  {
    name: 'APM Recommendation',
    type: IdmsUploadsTypeEnum.ApmRecommendation,
    path: '/assets/idms-templates/apm-recommendation.csv',
  },
  {
    name: 'APM Recommendation Status',
    type: IdmsUploadsTypeEnum.ApmRecommendationStatus,
    path: '/assets/idms-templates/apm-recommendation-status.csv',
  },
  {
    name: 'AF Inspection Priority',
    type: IdmsUploadsTypeEnum.AfInspectionPriority,
    path: '/assets/idms-templates/af-inspection-priority.csv',
  },
  {
    name: 'Update Equipments',
    type: IdmsUploadsTypeEnum.UpdateEquipments,
    path: '/assets/idms-templates/update-equipments.csv',
  },
  {
    name: 'Pipe Support',
    type: IdmsUploadsTypeEnum.PipeSupport,
    path: '/assets/idms-templates/pipe-support-update-equipments.csv',
  },
  {
    name: 'Span Distance',
    type: IdmsUploadsTypeEnum.SpanDistance,
    path: '/assets/idms-templates/span-distance-update-equipments.csv',
  },
];

export const plannerEquipmentTemplate = {
  name: 'Update Equipments',
  type: IdmsUploadsTypeEnum.UpdateEquipments,
  path: '/assets/idms-templates/update-equipments.csv',
};
